// Copyright (c) 2017+,COMUNICARE SOLUTIONS SA
// All rights reserved.
//
// Redistribution and use in source and binary forms, with or without modification,
// are NOT permitted.

import { Pipe, PipeTransform } from "@angular/core";
import {
  AbstractQuestionnaireResponse,
  AbstractScoring,
  IQuestionnaireResponse,
  IScoring,
  QuestionResponse,
} from "@comunicare/comunicare-interfaces";
import { TranslateService } from "@ngx-translate/core";
import { QuestionnaireResponse } from "./questionnaireResponse.model";

@Pipe({ name: "computeScoring" })
export class ComputeScoringPipe implements PipeTransform {
  transform(previousQ: Scoring, questionnaireResponse: QuestionnaireResponse): { difference: number; same: number; done: boolean } | null {
    if (!previousQ) {
      return { difference: null, same: null, done: false };
    }
    let difference = 0;
    let same = 0;
    questionnaireResponse?.group?.group?.forEach((groupQr) => {
      groupQr.question.forEach((q) => {
        const currentValue = q?.answer?.[0]?.valueCoding?.code;
        let prevQ: QuestionResponse = null;
        previousQ?.questionnaireResponse?.group?.group?.forEach((element) => {
          prevQ = element?.question?.find((q2: QuestionResponse) => q2?.linkId === q.linkId);
        });
        const previousValue = prevQ?.answer?.[0]?.valueCoding?.code;
        if (previousValue && currentValue !== previousValue) {
          difference++;
        } else {
          same++;
        }
      });
    });
    if (difference === 0 && same === 0) {
      return { difference: null, same: null, done: false };
    }
    return { difference, same, done: true };
  }
}

export class Scoring extends AbstractScoring {
  private translateService: TranslateService;

  constructor(data: IScoring, translateService: TranslateService) {
    super(data);
    this.translateService = translateService;
  }

  protected newQuestionnaireResponse(q: IQuestionnaireResponse): AbstractQuestionnaireResponse {
    return new QuestionnaireResponse(q);
  }
  protected translate(key: string): string {
    return this.translateService.instant(key);
  }
}
